import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  Typography,
  CircularProgress,
  Divider,
  Grid,
  Card,
  CardContent,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
} from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  width: { xs: "95%", md: 900 },
  maxHeight: "90vh",
  overflowY: "auto",
  boxShadow: 24,
  p: 4,
  borderRadius: 3,
};

export default function Kardex({ open, handleClose, usuarioId }) {
  const [loading, setLoading] = useState(true);
  const [kardexData, setKardexData] = useState(null);
  const API_BASE = process.env.REACT_APP_API_URL;
  const BASE_URL = API_BASE.replace("/api/v2", "");

  useEffect(() => {
    if (usuarioId && open) {
      const token = sessionStorage.getItem("access_token");
      setLoading(true);
      fetch(`${process.env.REACT_APP_API_URL}/estudiantes/${usuarioId}/kardex`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setKardexData(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error al cargar kardex:", err);
          setKardexData(null);
          setLoading(false);
        });
    }
  }, [usuarioId, open]);

  if (loading) {
    return (
      <Modal open={open} onClose={handleClose}>
        <Box sx={style} display="flex" justifyContent="center" alignItems="center">
          <CircularProgress />
        </Box>
      </Modal>
    );
  }

  if (!kardexData || !kardexData.usuario) {
    return (
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography color="error">No se encontró información del kardex o error en el servidor</Typography>
        </Box>
      </Modal>
    );
  }

  const {
  usuario,
  programa_info,
  historial_academico,
  detalle_evaluaciones,
  asistencias,
  arrastres,
  docentes,
  finanzas
} = kardexData;
  const perfil = usuario?.perfiles_estudiantes || {};

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h5" fontWeight="bold">
            📑 Kardex Académico
          </Typography>
          {programa_info && (
            <Chip 
              label={programa_info.tipo_programa} 
              color={programa_info.tipo_programa === 'CARRERA' ? "primary" : "secondary"} 
              variant="outlined" 
            />
          )}
        </Box>
        <Divider sx={{ mb: 2 }} />

        {/* 2. Datos Personales */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} md={7}>
            <Card variant="outlined" sx={{ height: "100%" }}>
              <CardContent>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  👤 Datos Personales
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                  }}
                >
                  {/* Foto de perfil */}
                  <Avatar
                    src={
                      perfil.foto_perfil
                        ? `${BASE_URL}/storage/${perfil.foto_perfil.replace(
                            /\\/g,
                            "/"
                          )}`
                        : `${BASE_URL}/storage/perfiles/avatarpredeterminado.png`
                    }
                    alt={`${usuario.name} ${usuario.apellido_paterno || ""}`}
                    sx={{
                      width: 110,
                      height: 110,
                      border: "2px solid #ddd",
                      flexShrink: 0,
                    }}
                  />

                  {/* Datos */}
                  <Box>
                    <Typography variant="body2">
                      <b>Nombre:</b>{" "}
                      {usuario.name} {usuario.apellido_paterno}{" "}
                      {usuario.apellido_materno}
                    </Typography>

                    <Typography variant="body2">
                      <b>CI:</b> {usuario.ci || "-"} {usuario.expedido || ""}
                    </Typography>

                    <Typography variant="body2">
                      <b>Celular:</b> {usuario.celular || "-"}
                    </Typography>

                    <Typography variant="body2">
                      <b>Email:</b> {usuario.email || "-"}
                    </Typography>

                    <Typography variant="body2">
                      <b>Fecha Nacimiento:</b>{" "}
                      {usuario.fecha_cumpleaños || "-"}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={5}>
            <Card variant="outlined" sx={{ height: "100%" }}>
              <CardContent>

                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  🎓 Perfil Estudiante
                </Typography>

                <Typography variant="body2">
                  <b>Código:</b> {perfil.codigo || "-"}
                </Typography>

                <Typography variant="body2">
                  <b>Institución:</b> {perfil.institucion || "-"}
                </Typography>

                <Typography variant="body2">
                  <b>País:</b> {perfil.pais || "-"}
                </Typography>

                <Typography variant="body2">
                  <b>Departamento:</b> {perfil.departamento || "-"}
                </Typography>

                <Typography variant="body2">
                  <b>Provincia:</b> {perfil.provincia || "-"}
                </Typography>

                <Typography variant="body2">
                  <b>Lugar Nacimiento:</b> {perfil.lugar_nacimiento || "-"}
                </Typography>

                <Typography variant="body2">
                  <b>Tipo Sangre:</b> {perfil.tipo_sangre || "-"}
                </Typography>

              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card variant="outlined">
              <CardContent>

                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  📞 Referencias
                </Typography>

                <Typography variant="body2">
                  <b>Nombre:</b> {perfil.referencia_nombre || "-"}
                </Typography>

                <Typography variant="body2">
                  <b>Relación:</b> {perfil.referencia_relacion || "-"}
                </Typography>

                <Typography variant="body2">
                  <b>Celular:</b> {perfil.celular_referencia || "-"}
                </Typography>

              </CardContent>
            </Card>
          </Grid>
          
        </Grid>
        <Card sx={{ mb: 2 }} variant="outlined">
          <CardContent>

            <Typography variant="h6" gutterBottom>
              📚 Información Académica
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    bgcolor: "#f5f7ff",
                    border: "1px solid #dbe4ff",
                    borderRadius: 2,
                  }}
                >
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block" }}
                  >
                    Carrera / Programa
                  </Typography>

                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    color="primary"
                  >
                    {programa_info?.programa || "-"}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} md={4}>
                <Typography variant="body2">
                  <b>Responsable inscripcion:</b> {programa_info?.responsable_inscripcion || "-"}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography variant="body2">
                  <b>Semestre/Año:</b> {programa_info?.semestre || "-"} {programa_info?.semestre_numero || "-"}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography variant="body2">
                  <Typography variant="body2"><b>Gestión:</b> {programa_info?.gestion || "-"}</Typography>
                </Typography>
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography variant="body2">
                  <b>Nivel Actual:</b> {programa_info?.nivel_actual || "-"}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography variant="body2">
                  <b>Tipo Inscripción:</b>{" "}
                  {programa_info?.tipo_inscripcion || "-"}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography variant="body2">
                  <b>Grupo:</b> {programa_info?.grupo || "-"}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography variant="body2">
                  <b>Modalidad:</b> {programa_info?.modalidad || "-"}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography variant="body2">
                  <b>Turno:</b> {programa_info?.turno || "-"}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography variant="body2">
                  <b>Días:</b> {programa_info?.dias || "-"}
                </Typography>
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography variant="body2">
                  <b>Fecha Inscripción:</b>{" "}
                  {programa_info?.fecha_inscripcion || "-"}
                </Typography>
              </Grid>

            </Grid>

          </CardContent>
        </Card>
        <Grid item xs={12}>
          <Typography variant="body2" mt={1}>
            <b>📂 Documentos Entregados:</b>
          </Typography>

          <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
            <Chip
              label="Título Bachiller"
              color={programa_info?.titulo_bachiller ? "success" : "default"}
              variant={programa_info?.titulo_bachiller ? "filled" : "outlined"}
            />
            <Chip
              label="Certificado Nacimiento"
              color={programa_info?.certificado_nacimiento ? "success" : "default"}
              variant={programa_info?.certificado_nacimiento ? "filled" : "outlined"}
            />
            <Chip
              label="CI Entregado"
              color={programa_info?.ci_entregado ? "success" : "default"}
              variant={programa_info?.ci_entregado ? "filled" : "outlined"}
            />
          </Box>
        </Grid>

        {/* 3. Tabla de Notas y Evaluaciones */}
        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>📝 Historial de Calificaciones</Typography>
        <TableContainer component={Paper} variant="outlined" sx={{ mb: 3 }}>
          <Table size="small">
            <TableHead sx={{ bgcolor: "#eee" }}>
              <TableRow>
                <TableCell><b>Materia / Código</b></TableCell>
                <TableCell align="center"><b>Nivel</b></TableCell>
                <TableCell align="center"><b>Gestión</b></TableCell>
                <TableCell align="center"><b>Calificaciones Parciales</b></TableCell>
                <TableCell align="center"><b>Final</b></TableCell>
                <TableCell align="center"><b>Estado</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {historial_academico?.length > 0 ? (
                historial_academico.map((mat, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Typography variant="body2" fontWeight="medium">{mat.materia}</Typography>
                      <Typography variant="caption" color="textSecondary">{mat.codigo}</Typography>
                    </TableCell>
                    <TableCell align="center">{mat.nivel}º</TableCell>
                    <TableCell align="center">{mat.gestion}</TableCell>
                    <TableCell align="center">
                      <Box display="flex" flexWrap="wrap" justifyContent="center" gap={0.5}>
                        {detalle_evaluaciones?.[mat.materia_id]?.map((ev, i) => (
                          <Chip 
                            key={i} 
                            label={`${ev.evaluacion.charAt(0)}: ${Math.round(ev.nota_total)}`} 
                            size="small" 
                            variant="outlined"
                          />
                        ))}
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <Typography fontWeight="bold" color={mat.nota_final >= 61 ? "success.main" : "error.main"}>
                        {mat.nota_final || 0}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Chip 
                        label={mat.estado} 
                        size="small" 
                        color={mat.estado === 'aprobado' ? "success" : mat.estado === 'en_curso' ? "warning" : "error"} 
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">No hay registros académicos disponibles</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* 4. Asistencias Recientes */}
        <Typography variant="h6" gutterBottom>📅 Control de Asistencia (Últimas)</Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
          {asistencias?.length > 0 ? (
            asistencias.slice(0, 10).map((asist, i) => (
              <Chip
                key={i}
                label={`${asist.fecha} - ${asist.materia}: ${asist.estado}`}
                color={asist.estado === 'asistio' ? "success" : "error"}
                variant="outlined"
                size="small"
              />
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">No se han registrado asistencias.</Typography>
          )}
        </Box>
        <Typography variant="h6" gutterBottom>
          💰 Costos Académicos
        </Typography>

        {finanzas?.length > 0 ? (
          <Box display="flex" flexDirection="column" gap={2} mb={3}>

            {finanzas.map((fin, i) => (
              <Paper
                key={i}
                elevation={1}
                sx={{
                  p: 2,
                  borderRadius: 2,
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={2}
                >

                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {fin.concepto}
                    </Typography>

                  </Box>

                  <Box textAlign="right">

                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "block" }}
                    >
                      Costo
                    </Typography>

                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      color="success.main"
                    >
                      Bs. {Number(fin.costo).toFixed(2)}
                    </Typography>

                  </Box>
                </Box>
              </Paper>
            ))}

          </Box>
        ) : (
          <Paper sx={{ p: 3, textAlign: "center", mb: 3 }}>
            <Typography color="text.secondary">
              No existen registros financieros
            </Typography>
          </Paper>
        )}
      </Box>
    </Modal>
  );
}